import { OperationPayload } from '../operation-payload.model';

export class InviteDriverPayload implements OperationPayload {
  path = '/accounts/drivers';
}
